<template>
  <table class="responsive-table">
    <slot />
  </table>
</template>

<script>
export default {
  name: 'ResponsiveTable',
};
</script>

<style lang="scss" scoped>
.responsive-table {
  &/deep/ {
    @include border-radius($border-radius);

    width: 100%;
    margin-bottom: $gutter;
    background: white;
    border: $default-border;
    border-collapse: separate; /* Don't collapse */
    border-spacing: 0;

    thead {
      position: sticky;
      z-index: 200;
      background: $white;
      inset-block-start: $header-height;

      th {
        position: relative;
        padding: 0.75rem;
        padding-right: $gutter;
        white-space: nowrap;
        background: white;
        border-top: solid 3px $red;
        border-bottom: $default-border;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        i,
        svg {
          position: absolute;
          top: 17px;
          right: 10px;
        }

        .fa-sort {
          z-index: 1;
          opacity: 0.2;
        }

        span {
          .fa-sort-up {
            z-index: 2;
            opacity: 0;
          }

          .fa-sort-down {
            z-index: 3;
            opacity: 0;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }
          }
        }

        &:hover {
          .fa-sort {
            opacity: 0.4;
          }

          span {
            .fa-sort-down {
              opacity: 1;
            }

            &.active-down {
              .fa-sort-down {
                opacity: 1;
              }

              .fa-sort-up {
                opacity: 0;
              }
            }

            &.active-up {
              .fa-sort-up {
                opacity: 1;
              }

              .fa-sort-down {
                opacity: 0;
              }
            }
          }
        }
      }
    }

    tbody {
      tr {
        td {
          padding: 0.75rem;
          color: rgba($black, 0.67);
          border-bottom: $secondary-border;

          a,
          .link {
            color: rgba($black, 0.67);

            &:hover {
              color: $light-blue;
            }

            &.email {
              color: darken($light-blue, 10%);
            }
          }

          .fa-battery-full,
          .fa-battery-three-quarters,
          .fa-battery-half,
          .fa-battery-quarter,
          .fa-battery-empty {
            position: relative;
            top: 1px;
            margin-right: 8px;
            color: darken($green, 5%);
            font-size: 20px;
            vertical-align: top;
          }

          .fa-battery-quarter,
          .fa-battery-empty {
            color: $red;
          }

          .battery-label {
            &.red {
              color: $red;
              font-weight: bold;
            }
          }

          span {
            display: inline-block;
            vertical-align: top;
          }

          &.actions {
            white-space: nowrap;

            a,
            button {
              @include border-radius($border-radius);

              display: inline-block;
              width: 30px;
              height: 30px;
              padding: 0;
              font-size: 14px;
              line-height: 30px;
              text-align: center;
              vertical-align: top;
              background: white;
              border: solid 1px #ddd;

              @media (max-width: $sm-max) {
                width: 45px;
                height: 45px;
                padding: 0;
                font-size: 15px;
                line-height: 43px;
                text-align: center;
              }

              &.btn-secondary {
                color: rgba(0, 0, 0, 0.67);
              }

              &.blue-hover {
                &:hover {
                  color: white;
                  background: $blue;
                  border-color: $blue;
                }
              }

              &.red-hover {
                &:hover {
                  color: white;
                  background: $red;
                  border-color: $red;
                }
              }

              &.green-hover {
                &:hover {
                  color: white;
                  background: $green;
                  border-color: $green;
                }
              }
            }

            @media (min-width: $md-min) {
              text-align: right;
            }

            @media (min-width: $lg-min) {
              text-align: right;

              button,
              a {
                opacity: 0;
              }
            }
          }
        }

        &:nth-of-type(odd) {
          background: $white;
        }

        &:last-of-type {
          td {
            border-bottom: $default-border;
          }
        }

        &:hover {
          td {
            background: $off-white;

            &.actions {
              button,
              a {
                opacity: 1;
              }
            }
          }
        }
      }
    }

    @media (max-width: $sm-max) {
      display: block;
      background: none;
      border: none;

      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      tbody {
        tr {
          background: $white;
          border: $default-border;

          td {
            padding: 0.75rem;
            text-align: right;
            border-top: none;
            border-bottom: $secondary-border;

            &:last-of-type {
              border-bottom: none;
            }
          }
        }
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        @include border-radius($border-radius);

        margin: 0 0 1rem 0;
        background: white;
      }

      td {
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: $secondary-border;

        label {
          position: absolute;
          top: 12.5px;
          left: 15px;
          width: 45%;
          padding-right: 10px;
          font-weight: bold;
          white-space: nowrap;
          text-align: left;
        }
      }
    }
  }
}

.data-download-table {
  tr {
    span {
      display: inline-block;
      margin-right: 5px;
    }
  }
}
</style>
